import React from "react";
import Banner from "../ComboAppPage/Banner/banner";
import { BannerDetails } from "../../bannerDetails";

const InterstitialErrorPage = () => {
  return (
    <div className="interstitial-page container-fluid">
      <Banner bannerDetails={BannerDetails.CREDIT_KARMA}/>
      <div className="interstitial-form interstitial-error-form-alignment">
        <div className="interstitial-form-header">
          <span className="too-many-attempts-lock-logo"/>
          <div>
            <h2> Too Many Attempts </h2>
            <div className="interstitial-form-paragraph">
              <span>You've exceeded the set limit of attempts to verify your information.</span>
              <span> Please wait 24 hours and try again.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterstitialErrorPage;
